module.exports = __webpack_public_path__ + "static/media/easy.6da08f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/easy.svg
// module id = 215
// module chunks = 8